import React from "react";
import { useNavigate } from "react-router-dom";
import "./production_homepage.css";

import kitchen_1 from "../../assets/images/ProductSection/kitchen_product.jpg";
import closet_1 from "../../assets/images/ProductSection/closet_product.jpg";
import tv_wall_1 from "../../assets/images/ProductSection/tv_wall_product.jpg";

const ProductsSection = () => {
  const navigate = useNavigate();

  const products = [
    {
      id: 1,
      title: "ชุดครัว FIT-IN",
      description: "ชุดครัวที่ออกแบบมาเพื่อให้เข้ากับพื้นที่ของคุณอย่างลงตัว พร้อมฟังก์ชันการใช้งานที่ครบครัน",
      image: kitchen_1
    },
    {
      id: 2,
      title: "ตู้เสื้อผ้า FIT-IN",
      description: "Walk-in Closet ที่ออกแบบเพื่อตอบสนองความต้องการในการจัดเก็บเสื้อผ้าอย่างเป็นระบบ",
      image: closet_1
    },
    {
      id: 3,
      title: "ชั้นวาง TV",
      description: "ชั้นวางทีวีที่ออกแบบมาเพื่อความสวยงามและตอบโจทย์การใช้งานในยุคปัจจุบัน",
      image: tv_wall_1
    }
  ];

  const handleViewProducts = () => {
    navigate('/products');
    // Scroll to top and refresh page
    window.scrollTo(0, 0);
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  return (
    <section className="products-section">
      <div className="products-container">
        <h2 className="products-title">ผลิตภัณฑ์ของเรา</h2>
        
        <div className="products-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-image-wrapper">
                <img 
                  src={product.image} 
                  alt={product.title}
                  className="product-image"
                />
                <div className="product-overlay">
                  <h3 className="product-title">{product.title}</h3>
                  <p className="product-description">{product.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="products-center-button">
          <button 
            className="products-main-button"
            onClick={handleViewProducts}
          >
            ดูรายละเอียดเพิ่มเติม
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;